import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';

import * as ConfirmAppointment from '../../shared/mocks/confirm-appointment-response.mock.json';
import * as EntranceTrees0 from '../../shared/mocks/entrance-trees-N0-response.mock.json';
import * as EntranceTrees1 from '../../shared/mocks/entrance-trees-N1-response.mock.json';
import * as EntranceTrees2 from '../../shared/mocks/entrance-trees-N2-response.mock.json';
import * as EntranceTrees3 from '../../shared/mocks/entrance-trees-N3-response.mock.json';
import * as EntranceTrees4 from '../../shared/mocks/entrance-trees-N4-response.mock.json';
import * as GetClient from '../../shared/mocks/get-client-dni-response.mock.json';
import * as GetDecisionTree from '../../shared/mocks/get-decision-tree-response.mock.json';
import * as GetTimesZone from '../../shared/mocks/get-times-zone-response.mock.json';
import * as OpenClaim from '../../shared/mocks/open-claim-response.mock.json';
import { EntranceTreesRequest } from '../../shared/models/dto/entrance-trees-request';

const RESPONSE_MOCKS: Map<string, string> = new Map([
	[environment.endpoints.getClient, JSON.stringify(GetClient)],
	[`${environment.endpoints.entranceTrees}0`, JSON.stringify(EntranceTrees0)],
	[`${environment.endpoints.entranceTrees}1`, JSON.stringify(EntranceTrees1)],
	[`${environment.endpoints.entranceTrees}2`, JSON.stringify(EntranceTrees2)],
	[`${environment.endpoints.entranceTrees}3`, JSON.stringify(EntranceTrees3)],
	[`${environment.endpoints.entranceTrees}4`, JSON.stringify(EntranceTrees4)],
	[environment.endpoints.getDecisionTree, JSON.stringify(GetDecisionTree)],
	[environment.endpoints.getTimesZone, JSON.stringify(GetTimesZone)],
	[environment.endpoints.confirmAppointment, JSON.stringify(ConfirmAppointment)],
	[environment.endpoints.openClaim, JSON.stringify(OpenClaim)]
]);
@Injectable()
export class MockInterceptor implements HttpInterceptor {
	intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		if (environment.useMock && req.url.includes(environment.apiURL)) {
			let url = req.url.replace(environment.apiURL, '');
			url = url.includes('EntranceTrees') ? this.getEntranceTreeLevelUrl(url, req.body as EntranceTreesRequest) : url;
			const body = JSON.parse(RESPONSE_MOCKS.get(url) ?? '{}');
			return of(new HttpResponse({ status: 200, body: body }));
		}
		return next.handle(req);
	}

	getEntranceTreeLevelUrl(url: string, body: EntranceTreesRequest): string {
		if (body.damageCauseId) {
			return url + '4';
		} else if (body.damageDetailId) {
			return url + '3';
		} else if (body.damageTypeId) {
			return url + '2';
		} else if (body.causeGroupId) {
			return url + '1';
		} else {
			return url + '0';
		}
	}
}
